import Rails from "@rails/ujs"
Rails.start()

import "@hotwired/turbo-rails"
Turbo.config.forms.mode = "optin"

import { initClarity, identifyClarityUser } from "../clarity"
initClarity()
identifyClarityUser()
document.addEventListener("turbo:load", identifyClarityUser)

import { Application } from "@hotwired/stimulus"

import LessonRegistrationsTabsController from "../controllers/course_operator/lesson_registrations_tabs_controller"
import PostRoundGatheringController from "../controllers/course_operator/post_round_gathering_controller"
import PlayerListViewController from "../controllers/course_operator/player_list_view_controller"
import RotationPatternController from "../controllers/course_operator/rotation_pattern_controller"
import RoundConfirmationController from "../controllers/course_operator/round_confirmation_controller"
import CoursesPortalSidebarController from "../controllers/front_end/courses_portal_sidebar_controller"
import CoursesPortalContextController from "../controllers/front_end/courses_portal_context_controller"

window.Stimulus = Application.start()
Stimulus.register("lesson-registrations-tabs", LessonRegistrationsTabsController)
Stimulus.register("post-round-gathering", PostRoundGatheringController)
Stimulus.register("player-list-view", PlayerListViewController)
Stimulus.register("rotation-pattern", RotationPatternController)
Stimulus.register("round-confirmation", RoundConfirmationController)
Stimulus.register("courses-portal-sidebar", CoursesPortalSidebarController)
Stimulus.register("courses-portal-context", CoursesPortalContextController)
